export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9679.318417b8.jpg";